import { gboReservationPath } from './session';
import { uiStateReservationsPath } from './uiState';

export const uiStateExtrasPath = [...uiStateReservationsPath, 'extras'];
export const bundlesPath = [...gboReservationPath, 'bundles'];
export const highlyRecommendedProtectionsPath = [...gboReservationPath, 'highly_recommended_protections'];
export const requiredProtectionsPath = [...gboReservationPath, 'protections_required_at_counter'];
